import { Layout } from "antd";
import useGlobalConfig from "@/store/global";

const { Footer } = Layout;

const LayoutFooter = () => {
  const {
    themeColor,
    program
  } = useGlobalConfig()

  const { name } = program
  const currentYear = new Date().getFullYear()
  
  return (
    <>
      <Footer
        style={{
          textAlign: "center",
          backgroundColor: themeColor,
          color: "#FFFFFF",
          position: 'relative'
        }}
      >
        © {currentYear} Medmonk, Inc. All rights reserved. # { name === 'alphanine' && "US/GX/0315/0052(2)" }
          { name === 'gamunex' && "US-GXC-2100198" }
          { name === 'koate' && "KT-0415-01-2018" }
          { name === 'prolastin' && "US/GX/0315/0052(2)" }
          { name === 'ryplazim' && "RY-0002-00-2021" }
          { name === 'xembify' && "US-XEM-2400242" }
      </Footer>
    </>
  );
};

export default LayoutFooter;
